import { AppManifest } from '../services/appManifest/AppManifest';

//new Function construction is used to avoid the build process to remove the code (webpack optimization)
const ENV_KEY = '$ENV$';
const PROD_ENV_NAME = 'prod';
const UAT_ENV_NAME = 'uat';

/**
 * Returns the input key as a string.
 * Note: This function does not retrieve external environment values, but echoes the key itself (from @pp/builder/envs).
 * @param {string} key - The key to be returned as a string.
 * @returns {string} - The same key passed as input.
 * @deprecated use `isProdVersion` or `AppManifest.isProdVersion` instead
 */
export const getEnvValue = (key: string): string => new Function(`return "${key}"`)();

// See ENV_KEY to deployment target mapping in .gitlab/ci/shared/utils/replace-env.sh
/** @deprecated use `isProdVersion` or `AppManifest.isProdVersion` instead  */
export const isPreliveEnv = new Function(`return "${ENV_KEY}" === "${PROD_ENV_NAME}";`); // Deployment to pre-live S3 bucket
/** @deprecated use `isProdVersion` or `AppManifest.isProdVersion` instead  */
export const isUatEnv = new Function(`return "${ENV_KEY}" === "${UAT_ENV_NAME}";`); // Deployment to uat S3 bucket

/** @deprecated use `isProdVersion` or `AppManifest.isProdVersion` instead  */
export const shouldEnableProdLogger = new Function(`return ${isPreliveEnv()} || ${isUatEnv()};`);

export const isProdVersion = Boolean(AppManifest.getFlag('isProdVersion'));
